// Find error element in a node (self or descendant)
function findErrorElement(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) {
        return null;
    }
    return node.matches('p.input-error') ? node : node.querySelector('p.input-error');
}

// Scroll to first error element found in added nodes
function scrollToErrorInNodes(nodes) {
    for (const node of nodes) {
        const errorElement = findErrorElement(node);
        if (errorElement) {
            errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return true;
        }
    }
    return false;
}

// Handle mutation: scroll to error if childList mutation contains error nodes
function handleMutation(mutation) {
    if (mutation.type === 'childList') {
        return scrollToErrorInNodes(mutation.addedNodes);
    }
    return false;
}

// Create a MutationObserver to watch for new nodes that include <p class="input-error">
let observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (handleMutation(mutation)) {
            return;
        }
    }
});

// Observer configuration: watch for nodes being added anywhere in the subtree
const config = { childList: true, subtree: true };

// Attach the observer to the form with class "stack"
const form = document.querySelector('form');
if (form) {
    observer.observe(form, config);
}
